import { mapValues } from 'lodash-es'
import { getCookieNamePrefix } from 'lib/helpers/getCookieNamePrefix/getCookieNamePrefix'

export const localStorageKeys = {
  gridColumnsDimensions: 'grid_columns_dimensions',
  gridColumnsOrder: 'grid_columns_order',
  gridColumnsVisibility: 'grid_columns_visibility',
  businessId: 'business_id',
  businessIdForBusinessStorage: 'business_id_for_business_storage',
  socureDeviceSessionOwner: 'socure_device_session_owner',
  invoiceDetailsVendorOCRDismissed: 'invoice_details_perspective_vendor_dismissed',
  invoiceDetailsCustomerOCRDismissed: 'invoice_details_customer_ocr_dismissed',
  billPayToOCRDismissed: 'bill_pay_to_ocr_dismissed',
  plaidLinkToken: 'plaid_link_token',
  plaidOAuthRedirectUrl: 'plaid_oauth_redirect_url',
  navatticTour: 'navattic_tour',
  shopifyIntegrationPreferences: 'shopify_integration_preferences',
  settingsTabGroups: 'settings_tab_groups',
  payerReceivablesGroupOpen: 'payer_receivables_group_open',
  receivableConnectStripeMessageDismissed: 'receivable_connect_stripe_message_dismissed',
  payerPayablesGroupOpen: 'payer_payables_group_open',
  purchasingGroupOpen: 'purchasing_group_open',
  moreGroupOpen: 'more_group_open',
  vendorReceivablesGroupOpen: 'vendor_receivables_group_open',
  desktopNavigationDrawerOpen: 'desktop_navigation_drawer_open',
  searchByVendorNameSuggestions: 'search_by_vendor_name_suggestions',
  defaultTableGroup: {
    payables: 'initial_table_group_payables',
    receivables: 'initial_table_group_receivables',
    payments: 'initial_table_group_payments',
    purchaseOrders: 'initial_table_group_purchase_orders',
    catalog: 'initial_table_group_catalog',
  },
  tableTabsStore: {
    payables: 'payables-tabs',
    payments: 'payments-tabs',
    purchaseOrders: 'purchase-orders-tabs',
    receivables: 'receivables-tabs',
    salesOrders: 'sales-orders-tabs',
    workOrders: 'work-orders-tabs',
    receipts: 'receipts-tabs',
    docsAndReports: 'docs-and-reports-tabs',
    locations: 'locations-tabs',
    insights: 'insights-tabs',
  },
  tableExpandGroupsStateStore: {
    inventory: 'inventory-expand-groups',
  },
  tableColumns: {
    vendors: 'vendors_table_columns',
    purchasers: 'purchasers_table_columns',
    purchaseOrders: 'purchase_orders_table_columns',
    receipts: 'receipts_table_columns',
    payments: {
      all: 'payments_columns_all',
      scheduled: 'payments_columns_scheduled',
      initiated: 'payments_columns_initiated',
      paid: 'payments_columns_paid',
      failed: 'payments_columns_failed',
      inReview: 'payments_columns_in_review',
      onHold: 'payments_columns_on_hold',
      canceled: 'payments_columns_canceled',
    },
  },
  dataGridState: {
    vendors: 'vendors_data_grid_state',
    purchasers: 'purchasers_data_grid_state',
    receivables: 'receivables_data_grid_state',
    clientManagerTeamMembers: 'client-manager-team-members',
    clientManagerClients: 'client-manager-clients',
  },
  dashboardWidgetsExpanded: 'dashboard_widgets_expanded',
  receivableSyncMessageDismissed: 'receivable_sync_message_dismissed',
  tabs: {
    receivables: 'receivables_visible_tabs',
    payables: 'payables_visible_tabs',
    payments: 'payments_visible_tabs',
    catalog: 'catalog_visible_tabs',
  },
  mfaVerificationLockedEmail: 'mfa_verification_locked_email',
  mfaVerificationLockedAt: 'mfa_verification_locked_at',
  hideOpenInQBOWarn: 'hide_open_in_qbo_warn',
  redirectToPathAfterAccountingConnection: 'redirect_to_path_after_accounting_connection',
  paymentPaginationPage: 'payment_pagination_page',
  payablesPaginationPage: 'payables_pagination_page',
  billsNavigationWithinPage: 'payables_navigation_within_page',
  receivablesPaginationPage: 'receivables_pagination_page',
  receivablesPaginationVariables: 'payables_pagination_variables',
  vendorCreditsNavigationWithinPage: 'vendor_credits_navigation_within_page',
  dismissedTodos: 'dismissed_todos',
  dismissedBannerIds: 'dismissed_banner_ids',
  autoItemizationBannerDismissed: 'auto_itemization_banner_dismissed',
  vendorFinancingBannerDismissed: 'vendor_financing_banner_dismissed',
  isLendingJourneyDismissed: 'is_lending_journey_dismissed',
  hasLendingJourneyToDos: 'has_lending_journey_to_dos',
  hasBizDetailsSubmitted: 'has_biz_details_submitted',
  viewedSettings: 'viewed_settings',
  dontShowMatchingGuide: 'dont_show_matching_guide',
  guidedPurchaseOrderItemizationBubbles: 'guided_purchase_order_itemization_bubbles',
  guidedReceiptItemizationBubbles: 'guided_receipt_itemization_bubbles',
  guidedBillItemizationBubbles: 'guided_bill_itemization_bubbles',
  similarCatalogItemsFoundBubble: 'similar_catalog_items_found_bubble',
  refreshedCatalogBubble: 'catalog_v2_bubble',
  addInvoiceOptionsBubble: 'add_invoice_options_bubble',
  itemizeLinkedDocumentBubble: 'itemize_linked_document_bubble',
  documentCommentsButtonBubble: 'document_comments_button_bubble',
  apForecastBetaEnabled: 'ap_forecast_beta_enabled',
  discrepancyRulesUpsellBubble: 'discrepancy_rules_upsell_bubble',
  createDocumentBubble: 'create_document_bubble',
  payableDialogSettings: 'payable_dialog_settings',
  purchaseOrderDialogSettings: 'purchase_order_dialog_settings',
  receivableDialogSettings: 'receivable_dialog_settings',
  catalogItemDialogSettings: 'catalog_item_dialog_settings',
  missingBaselineCostsBannerDismissed: 'missing_baseline_costs_banner_dismissed',
  catalogItemSalesSourceShopifyItems: 'catalog_item_sales_source_shopify_items',
  catalogItemPurchaseSourceItems: 'catalog_item_purchase_source_items_',
  forceHideSyncInventoryWidget: 'force_hide_sync_inventory_widget',
  clientManagerBackUrl: 'client_manager_back_url',
  unscheduledBillsInCashOutflowEnabled: 'unscheduled_bills_in_cash_outflow_enabled',
  displayCombinedSyncStatusCard: 'display_combined_sync_status_card_v2',
  skuAliasesBannerDismissed: 'sku_aliases_banner_dismissed',
  billsForFinancingNudgeBannerDismissed: 'bills_for_financing_nudge_banner_dismissed',
  billForFinancingNudgeMessageDismissed: 'bill_for_financing_nudge_message_dismissed',
  userSettings: 'user_settings',
  dismissedActivationJourneyCards: 'dismissed_activation_journey_cards_v2',
  purchaseOrderApparelViewGuideBubble: 'purchase_order_apparel_view_guide_bubble',
  detailsDialogWindowMode: 'details_dialog_mode',
  dismissedBillPossibleDuplicatesWarnings: 'dismissed_bill_possible_duplicates_warnings',
  recentFieldSearches: 'recent_field_searches',
  workingCapitalUpsellDismissed: 'working_capital_upsell_dismissed',
  purchaseOrderApparelViewGuideDismissed: 'purchase_order_apparel_view_guide_dismissed',
} as const

export const sessionStorageKeys = {
  featureSessionLimit: 'feature_session_limit',
  matchingGuideShown: 'matching_guide_shown',
  matchingFeedbackButtonsShown: 'matching_feedback_buttons_shown',
  isDemoScheduled: 'is_demo_scheduled',
  isConnectShopifyNudgeDismissed: 'is_connect_shopify_nudge_dismissed',
  impersonationIndicatorDismissed: 'impersonation_indicator_dismissed',
  doNotShowInviteVendorsBanner: 'do_not_show_invite_vendors_banner',
  doNotShowRelatedPaymentBanner: 'do_not_show_related_payment_banner',
  activationJourneyAnimationShown: 'activation_journey_animation_shown',
  receiptFormDetailsOpen: 'receipt_form_details_open',
  poFormDetailsOpen: 'po_form_details_open',
  poFormDeliveryOpen: 'po_form_delivery_open',
  poFormContactDetailsOpen: 'po_form_contact_details_open',
  poFormApForecastOpen: 'po_form_ap_forecast_open',
  poLineItemsOpen: 'po_line_items_open',
  billFormLinkedDocsOpen: 'bill_form_linked_docs_open',
  billFormDetailsOpen: 'bill_form_details_open',
  billFormSummaryOpen: 'bill_form_summary_open',
  linkedToReceiptDocsSectionOpen: 'linked_to_receipt_docs_section_open',
  receiptDeliverySectionOpen: 'receipt_delivery_section_open',
  docsLinkedInvoicesListOpen: 'docs_tab_linked_invoices_list_open',
  docsLinkedReceiptsListOpen: 'docs_tab_linked_receipts_list_open',
  docsLinkedPurchaseOrderListOpen: 'docs_tab_linked_purchase_order_list_open',
  docsLinkedWorkOrdersListOpen: 'docs_tab_linked_work_order_list_open',
  docsLinkedVendorCreditsOpen: 'docs_tab_linked_vendor_credits_open',
  docsOtherAttachmentsOpen: 'docs_tab_other_attachments_open',
  salesOrderReceivableInvoicesOpen: 'sales_order_receivable_invoices_open',
  salesOrderLinkedInvoicesOpen: 'sales_order_linked_invoices_open',
  salesOrderOtherAttachmentsOpen: 'sales_order_other_attachments_open',
  locationDialogDetailsSectionOpen: 'location_dialog_details_section_open',
  locationDialogAddressSectionOpen: 'location_dialog_address_section_open',
  locationDialogOperationsDetailsSectionOpen: 'location_dialog_operations_details_section_open',
  unlinkedCatalogItemsDismissed: 'unlinked_catalog_items_dismissed',
  unlinkedReceiptsDismissed: 'unlinked_receipts_dismissed',
  unreviewedSalesChannelConfigurationsDismissed: 'unreviewed_sales_channel_configurations_dismissed',
  salesOrderSections: {
    detailsOpen: 'sales_order_details_section_open',
    fulfillmentsOpen: 'sales_order_fulfillments_section_open',
  },
  paymentDetailsDialog: {
    detailsSectionOpen: 'payment_details_dialog_details_section_open',
    termsSectionOpen: 'payment_details_dialog_terms_section_open',
    timelineSectionOpen: 'payment_details_dialog_timeline_section_open',
  },
  billDetailsDialog: {
    detailsSectionOpen: 'bill_details_dialog_details_section_open',
    lineItemsSectionOpen: 'bill_details_dialog_line_items_section_open',
    accountingSectionOpen: 'bill_details_dialog_accounting_section_open',
  },
  invoiceDetailsDialog: {
    detailsSectionOpen: 'invoice_details_dialog_details_section_open',
    lineItemsSectionOpen: 'invoice_details_dialog_line_items_section_open',
  },
  catalogItemSections: {
    detailsOpen: 'catalog_item_details_section_open',
    purchaseSourcesOpen: 'catalog_item_purchase_section_open',
    salesChannelsOpen: 'catalog_item_sales_channels_open',
    barcodesOpen: 'catalog_item_barcodes_open',
    propertiesOpen: 'catalog_item_properties_section_open',
    billOfMaterialsOpen: 'catalog_item_bill_of_materials_section_open',
    landedCostOpen: 'catalog_item_landed_cost_section_open',
    locationsOpen: 'catalog_item_locations_open',
    baselineCostOpen: 'catalog_item_baseline_cost_section_open',
    dimensionsOpen: 'catalog_item_dimensions_section_open',
    sourcesOpen: 'catalog_item_sources_section_open',
  },
  workOrderSections: {
    detailsOpen: 'work_order_details_section_open',
    deliveryOpen: 'work_order_delivery_section_open',
    contactDetailsOpen: 'work_order_contact_details_section_open',
    lineItemsOpen: 'work_order_line_items_section_open',
    additionalExpensesOpen: 'work_order_additional_expenses_section_open',
  },
  purchaseOrderSections: {
    detailsOpen: 'purchase_order_details_section_open',
    paymentsOfLinkedInvoicesOpen: 'purchase_order_payments_of_linked_invoices_section_open',
    paymentsForSelectedVendorOpen: 'purchase_order_payments_for_selected_vendor_section_open',
    paymentsForOtherVendorsOpen: 'purchase_order_payments_for_other_vendors_section_open',
    standalonePaymentsOpen: 'purchase_order_standalone_payments_section_open',
    suggestedPaymentsOpen: 'purchase_order_suggested_payments_section_open',
    additionalExpensesOpen: 'purchase_order_additional_expenses_section_open',
  },
  inventoryManagementActivationJourneyCardDismissed: 'inventory_management_activation_journey_card_dismissed',
  GRNDetailsOpen: 'grn_details_open',
  GRNDeliveryOpen: 'grn_delivery_open',
  GRNLineItemsOpen: 'grn_line_items_open',
  googleSignupData: 'google_signup_data',
  googleSignupDataSavedAt: 'google_signup_data_saved_at',
  mfaEmail: 'mfa_email',
  mfaAvailableMethods: 'mfa_available_methods',
  dismissedPaymentNotices: 'dismissed_payment_notices',
}

/** Names before the environment prefix (see getCookieNamePrefix); read and write cookies via `cookieKeys`. */
export const cookieBaseNames = {
  token: 'token',
  deviceToken: 'device_token',
  profileId: 'profile_id',
  socureDeviceSession: 'socure_device_session',
  cin7DataToken: 'cin7_data_token',
  appLayoutNavigationMenu: 'app_layout_navigation_menu',
  suppressedConfirmShopifyPlanBanner: 'suppressed_confirm_shopify_plan_banner',
  shopifyAuthSearchParams: 'shopify_auth_search_params',
  simplifiedWcOnboarding: 'simplified_wc_onboarding',
  businessId: 'business_id',
} as const

const cookieNamePrefix = getCookieNamePrefix({ backendUrl: process.env.BACKEND_APP_URL })

export const cookieKeys = mapValues(cookieBaseNames, (name) => `${cookieNamePrefix}${name}`)
